import { displayToast } from '../../../../helpers/notification';
import { FaqTypes as Type } from '../../../types/faq';

export function AddFaqRequest(body: any) {
  return {
    type: Type.ADD_FAQ_REQUEST,
    payload: body,
  };
}

export function AddFaqRequestSuccess(data: any) {
  return {
    type: Type.ADD_FAQ_REQUEST_SUCCESS,
    payload: data,
  };
}

export function AddFaqRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }

  return {
    type: Type.ADD_FAQ_REQUEST_FAILURE,
    error: error,
  };
}

export function resetStateAddFaq() {
  return {
    type: Type.RESET_ADD_FAQ_STATE,
  };
}
